export const selectedUnitSelector = ({ units: { unit: value } }: any) => value;
export const singleUnitSelector = ({ units: { singleUnit: value } }: any) => value;
export const multiUnitSelector = ({ units: { multiUnit: value } }: any) => value;
export const multiUnitsSelector = ({ units: { units: value } }: any) => value;
export const selectedPhotoFilterSelector = ({ units: { selectedPhotoFilter: value } }) => value;
export const roomCreatedSelector = ({ units: { roomCreated: value } }: any) => value;
export const selectedMultiUnitSelector = ({ units: { selectedMultiUnit: value } }: any) => value;
